module.exports = "/images/party software center.svg?f589096d03f783957c199cf3e4875e71";